import Environment from './Environment'
import Standard from './Standard'

export default class Audit {
  constructor(audit = {}) {
    this.id = audit.id || null
    this.number = audit.number || ''
    this.app_id = audit.app_id || ''
    this.environment_id = audit.environment_id || ''
    this.standard_id = audit.standard_id || ''
    this.findings = audit.findings || []
    this.processes = audit.processes || []
    this.standard = audit.standard || new Standard()
    this.environment = audit.environment || new Environment()
    this.completed_at = audit.completed_at || ''
    this.created_at = audit.created_at || ''
    this.compliance_percentage = audit.compliance_percentage || 0
    this.status = audit.status || ''
  }

  mutations() {
    return {
      setAudit: (state, payload) => state.audit = new Audit(payload),
      clearAudit: (state) => state.audit = new Audit(),
      updateSite: (state, appId) => state.audit.app_id = appId,
      updateEnv: (state, envId) => state.audit.environment_id = envId,
      updateStandard: (state, standardId) => state.audit.standard_id = standardId,
    }
  }
}